import React from 'react';
import { motion } from 'framer-motion';
import { Wrench } from 'lucide-react';
import { essentialTools } from '../data/tools';
export function ToolsSection() {
  return <section className="py-24 px-4 bg-cream border-y border-mist" data-id="element-213" data-mp="39q2n6l0bangy">
      <div className="max-w-5xl mx-auto" data-id="element-214" data-mp="3nisacsrktyfn">
        <div className="text-center mb-16" data-id="element-215" data-mp="3jhyqcah993s1">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-3 text-brand" data-id="element-216" data-mp="3jj04intki6dz">The 2 Essential Teaching Tools</h2>
          <p className="text-lg text-ink/70" data-id="element-217" data-mp="2vse2bd68vgbw">
            Included as part of the 6-in-1 system — not sold separately anywhere.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-218" data-mp="34t2j2fn0vush">
          {essentialTools.map((tool, index) => <motion.article key={tool.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-ivory border border-gold/40 rounded-2xl p-8 flex flex-col" data-id="element-219" data-mp="2zsoa8vdlkgte" data-mpi={index}>
              <div className="w-12 h-12 bg-brand rounded-full flex items-center justify-center text-gold mb-6" data-id="element-220" data-mp="2i84qo45i6r28">
                <Wrench size={22} aria-hidden="true" data-id="element-221" data-mp="2m9hw4d4oos8m" />
              </div>
              <div className="text-gold-dark font-bold text-sm uppercase tracking-wider mb-2" data-id="element-222" data-mp="2r7jgd1duixlo">🔧 {tool.id}</div>
              <h3 className="text-xl font-serif font-bold mb-2 text-brand" data-id="element-223" data-mp="2w3qngxhzaf57">{tool.title}</h3>
              <p className="text-forest text-sm font-medium mb-4 italic" data-id="element-224" data-mp="1yjvxprw4yh1o">{tool.subtitle}</p>
              {tool.paragraphs.map(paragraph => <p key={paragraph} className="text-ink/75 text-sm mb-4 leading-relaxed" data-id="element-225" data-mp="28fqnd6ys1cdy">
                  {paragraph}
                </p>)}
              <p className="text-brand font-bold text-sm mt-auto pt-4 border-t border-mist" data-id="element-226" data-mp="2d91xbgyvy9a3">{tool.closing}</p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}